import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 基本路由，单独页，无需使用layout
let r = [{
  path: '/',
  // redirect: '/home',
  component: () => import('@/views/Layout'),
  children: [{
    path: '/',
    name: 'home',
    component: () => import('@/views/layout/Content')
  }]
}, {
  path: '/500',
  name: '500',
  component: () => import('@/views/500')
}, {
  path: '/404',
  name: '404',
  component: () => import('@/views/404')
}, {
  path: '*',
  // name: '404',  // 不能添加name值，否则会直接跳转至该404页面
  redirect: '/404'
}]

export default new Router({
  routes: r,
  // h5的history路由模式，即使用/斜线而非#锚点
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js